import ManagementsUpdateGasFlow from "../../components/ManagementsUpdate/ManagementsUpdateGasFlow/ManagementsUpdateGasFlow";

function ManagementsUpdateGasFlowPage() {
  return <ManagementsUpdateGasFlow />;
}

export default ManagementsUpdateGasFlowPage;
